import actionsTypes from './types';

export const getPaymentInformation = (body) => ({
  type: actionsTypes.GET_PAYMENT_INFORMATION,
  payload: { body },
});

export const getPaymentInformationRequest = () => ({
  type: actionsTypes.GET_PAYMENT_INFORMATION_REQUEST,
});

export const getPaymentInformationSuccess = (data) => ({
  type: actionsTypes.GET_PAYMENT_INFORMATION_SUCCESS,
  payload: { data },
});

export const getPaymentInformationFailure = (informations) => ({
  type: actionsTypes.GET_PAYMENT_INFORMATION_FAILURE,
  payload: { informations },
});

export const setPaymentScreen = (screen) => ({
  type: actionsTypes.SET_PAYMENT_SCREEN,
  payload: { screen },
});
